import { ServicesList } from "../../Types/state/masterdata";

export interface IState {
  services: ServicesList[];
  servicesCount: number;
}

type Action = any;

export const servicesReducer = (
  state: IState = {
    services: [],
    servicesCount: 0,
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_SERVICES":
      return {
        ...state,
        services: action?.payload?.page == 1 ? action?.payload?.data : [...state?.services, ...action?.payload?.data],
        servicesCount: action?.payload?.count,
      };
    case "ADD_CHANGE_ORDER_SERVICE":
      return {
        ...state,
        services: [action?.payload, ...state.services],
      };
    case "DELETE_SERVICE":
      return {
        ...state,
        services: state?.services?.filter((elem: any) => elem?._id != action?.payload),
      };
    case "UPDATE_SERVICE_DRAG_DROP":
      return {
        ...state,
        services: state?.services?.map((elem: any) => {
          if (elem?._id == action?.payload?.id) {
            return { ...elem, task: action?.payload?.task };
          }
          return elem;
        }),
      };
    case "UPDATE_SERVICE_DELETE_MAT_TAS_CON":
      return {
        ...state,
        services: state?.services?.map((elem: any) => {
          return {
            ...elem,
            task: elem?.task?.filter((ta: any) => ta?._id != action?.payload),
            material: elem?.material?.filter((ma: any) => ma?._id != action?.payload),
            consumable: elem?.consumable?.filter((co: any) => co?._id != action?.payload),
          };
        }),
      };
    case "UPDATE_NAME_AND_CATEGORY":
      const storageCategoryId = process.env.REACT_APP_STORAGE_ID;
      const storageFIXCategoryId = process.env.REACT_APP_STORAGE_FIX_ID;
      return {
        ...state,
        services: state?.services?.map((elem: any) => {
          if (
            storageCategoryId == action?.payload?.category?.slug ||
            storageFIXCategoryId == action?.payload?.category?.slug
          ) {
            if (elem?._id == action?.payload?._id) {
              return action?.payload;
            }
          } else {
            if (elem?._id == action?.payload?._id) {
              return { ...elem, name: action?.payload?.name, category_id: action?.payload?.category_id };
            }
          }
          return elem;
        }),
      };
    case "ADD_TASK_IN_SERVICE":
      return {
        ...state,
        services: state?.services?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return { ...elem, task: action?.payload?.task };
          }
          return elem;
        }),
      };
    case "ADD_MATERIAL_IN_SERVICE":
      return {
        ...state,
        services: state?.services?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return { ...elem, material: action?.payload?.material };
          }
          return elem;
        }),
      };
    case "ADD_CONSUMABLE_IN_SERVICE":
      return {
        ...state,
        services: state?.services?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return { ...elem, consumable: action?.payload?.consumable };
          }
          return elem;
        }),
      };
    case "DELETE_TASK_SERVICE":
      return {
        ...state,
        services: state?.services?.map((elem: any) => {
          if (elem?._id == action?.payload?.service_id) {
            return { ...elem, task: elem?.task?.filter((elem: any) => elem?._id != action?.payload?.task_id) };
          }
          return elem;
        }),
      };
    case "DELETE_CONSUMABLE_SERVICE":
      return {
        ...state,
        services: state?.services?.map((elem: any) => {
          if (elem?._id == action?.payload?.service_id) {
            return {
              ...elem,
              consumable: elem?.consumable?.filter((elem: any) => elem?._id != action?.payload?.consumable_id),
            };
          }
          return elem;
        }),
      };
    case "DELETE_MATERIAL_SERVICE":
      return {
        ...state,
        services: state?.services?.map((elem: any) => {
          if (elem?._id == action?.payload?.service_id) {
            return {
              ...elem,
              material: elem?.material?.filter((elem: any) => elem?._id != action?.payload?.material_id),
            };
          }
          return elem;
        }),
      };
    case "SET_TASKS_ORDER":
      
      return {
        ...state,
        services: state?.services?.map((elem: any) =>
          elem?._id == action?.payload?.id ? { ...elem, task: action.payload?.data } : elem
        ),
      };

    default:
      return state;
  }
};
